import React, { useEffect } from "react";
import { Route, Routes, useParams, useLocation, useNavigate } from "react-router-dom";

// Layout commun avec Header
import HeaderV2 from './components/HeaderV2';

// Pages
import Home from './pages/Home';
import SearchPrestataires from './pages/SearchPrestataires';
import Subscription from './pages/Subscription';
import AdminDashboard from './pages/AdminDashboard';
import Connexion from './pages/Connexion';
import WebRTCVideoCall from './components/WebRTCVideoCall';
import ProfilClient from './pages/ProfilClient';
import ServiceCategory from './pages/ServiceCategory';
import ServiceDetail from './pages/ServiceDetail';
import DemanderService from './pages/DemanderService';
import FormTemplateEditor from './pages/FormTemplateEditor';
import FormTemplateForm from "./components/FormTemplateForm";
import FormBuilder from "./components/FormBuilder";
import EspacePrestataire from "./pages/EspacePrestataire";
import DashboardRouter from "./pages/DashboardRouter";
import EspaceDonneurDOrdres from "./pages/EspaceDonneurDOrdres";
import ResetPassword from "./components/ResetPassword";
import Cgu from "./components/Cgu";
import AssistanceButton from "./components/AssistanceButton";
import SharedPrestataire from "./components/SharedPrestataire";

// Layout de page avec HeaderV2
const PageLayout = ({ children }) => (
    <div className="container-fluid">
        <HeaderV2 />
        {children}
        <AssistanceButton />
    </div>
);
// Layout de page avec HeaderV2
const PageLayoutDashboard = ({ children }) => (
    <div className="container-fluid">
        {children}
        <AssistanceButton />
    </div>
);

// Wrapper pour injecter l'id de l'URL dans l'éditeur
function EditorWrapper() {
    const { id } = useParams();
    return <FormTemplateEditor templateId={id} />;
}


// Redirection basée sur la langue
const LanguageRedirectHandler = () => {
    const { lang } = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const isBot = /bot|crawl|slurp|spider|mediapartners/.test(
            navigator.userAgent.toLowerCase()
        );

        if (!isBot) {
            const cleanPath = location.pathname.replace(`/${lang}`, '') || '/';
            localStorage.setItem("lang", lang);
            navigate(cleanPath + location.search, { replace: true });
        }
    }, [lang, location.pathname, location.search, navigate]);

    return null;
};

export default function AppRoutes() {
    const apiUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const registerVisit = () => {
            fetch(apiUrl + '/api/visit/register', {
                method: 'POST',
                credentials: 'include',
            }).catch(error => {
                console.error('Erreur visite:', error);
            });
        };

        // Au chargement
        registerVisit();

        // Puis régulièrement
        const interval = setInterval(registerVisit, 60 * 60 * 1000);

        return () => clearInterval(interval);
    }, []);
    return (
        <Routes>
            <Route path="/" element={<PageLayout><Home /></PageLayout>} />
            <Route path="/presta/:id" element={<PageLayout><SharedPrestataire/></PageLayout>}/>
            <Route path="/demander-service/:service/:step" element={<PageLayout><DemanderService /></PageLayout>} />
            <Route path="/search" element={<PageLayout><SearchPrestataires /></PageLayout>} />
            <Route path="/subscription" element={<PageLayout><Subscription /></PageLayout>} />
            <Route path="/dashboard" element={<PageLayoutDashboard><DashboardRouter /></PageLayoutDashboard>} />
            <Route path="/home" element={<PageLayoutDashboard><AdminDashboard /></PageLayoutDashboard>} />
            <Route path="/messages" element={<PageLayout><AdminDashboard /></PageLayout>} />
            <Route path="/account" element={<PageLayout><AdminDashboard /></PageLayout>} />
            <Route path="/connexion" element={<PageLayout><Connexion /></PageLayout>} />
            <Route path="/profil" element={<PageLayout><ProfilClient /></PageLayout>} />
            <Route path="/admin/form-templates/new" element={<PageLayout><FormTemplateEditor /></PageLayout>} />
            <Route path="/admin/form-templates/:id" element={<PageLayout><EditorWrapper /></PageLayout>} />
            <Route path="/admin/templates" element={<PageLayout><FormBuilder /></PageLayout>} />
            <Route path="/cgu" element={<PageLayout><Cgu /></PageLayout>} />
            <Route path='/testCallVideo' element={<PageLayout><WebRTCVideoCall /></PageLayout>} />
            <Route path="/:categorySlug" element={<PageLayout><ServiceCategory /></PageLayout>} />
            <Route path="/:categorySlug/:serviceSlug" element={<PageLayout><ServiceDetail /></PageLayout>} />
            <Route path="/reset-password/:token" element={<PageLayout><ResetPassword /></PageLayout>} />
            <Route path="/espace-prestataire" element={<PageLayout><EspacePrestataire /></PageLayout>} />
            <Route path="/espace-prestataire/:categorySlug" element={<PageLayout><ServiceCategory /></PageLayout>} />
            <Route path="/espace-prestataire/:categorySlug/:serviceSlug" element={<PageLayout><ServiceDetail /></PageLayout>} />
            <Route path="/espace-prestataire/codePlace" element={<PageLayout><EspacePrestataire /></PageLayout>} />
            <Route path="/espace-prestataire/profil" element={<PageLayout><ProfilClient /></PageLayout>} />
            <Route path="/espace-donneur-ordre" element={<PageLayout><EspaceDonneurDOrdres /></PageLayout>} />


            {/* Routes avec langue */}
            <Route path="/:lang" element={<LanguageRedirectHandler />} />
            <Route path="/:lang/search" element={<LanguageRedirectHandler />} />
            <Route path="/:lang/subscription" element={<LanguageRedirectHandler />} />
            <Route path="/:lang/connexion" element={<LanguageRedirectHandler />} />
            <Route path="/:lang/home" element={<LanguageRedirectHandler />} />
            <Route path="/:lang/dashboard" element={<LanguageRedirectHandler />} />
            <Route path="/:lang/messages" element={<LanguageRedirectHandler />} />
            <Route path="/:lang/profil" element={<LanguageRedirectHandler />} />
            <Route path="/:lang/testCallVideo" element={<LanguageRedirectHandler />} />
            <Route path="/:lang/:categorySlug" element={<LanguageRedirectHandler />} />
            <Route path="/:lang/:categorySlug/:serviceSlug" element={<LanguageRedirectHandler />} />
            <Route path="/:lang/demander-service/:service/:step" element={<LanguageRedirectHandler />} />
            <Route path='/:lang/admin/form-templates/new' element={<LanguageRedirectHandler />} />
            <Route path='/:lang/admin/form-templates/:id' element={<LanguageRedirectHandler />} />
            <Route path='/:lang/admin/templates' element={<LanguageRedirectHandler />} />
            <Route path='/:lang/espace-prestataire' element={<LanguageRedirectHandler />} />
            <Route path='/:lang/espace-prestataire/:categorySlug' element={<LanguageRedirectHandler />} />
            <Route path='/:lang/espace-prestataire/:categorySlug/:serviceSlug' element={<LanguageRedirectHandler />} />
            <Route path='/:lang/espace-prestataire/codePlace' element={<LanguageRedirectHandler />} />
            <Route path='/:lang/reset-password/:token' element={<LanguageRedirectHandler />} />
            <Route path='/:lang/espace-donneur-ordre' element={<LanguageRedirectHandler />} />


        </Routes>
    );
}
